<template>
  <div class="scrollbar o-y-auto" style="background-color: #F4F8FF;height: calc(100% - 0px)">
    <base-page-component :has-back="false" :has-nav="false">
      <div style="background-color: white;height: calc(100% - 0px);padding-top: 20px"
      >

        <up-load-image @uploadSuccess="uploadImageSuccess"
                       accept="image/*"
                       multiple
                       class="m-auto flex-column"
                       style="width: 800px"
                       picurl="company/about/"
        >
          <div slot="tip"
          >

            <div style="width: 800px;height: 400px;background-color: #F6F8FC;"
                 v-if="imgs.length===0"
                 class="m-auto flex-column">
              <img src="../../../assets/common/ic_upload_icons@2x.png"
                   style="width: 68px;height: 68px">

              <div class="m-t-40">将图标svg文件拖拽至此区域上传图标</div>

              <Button type="primary" class="m-t-20" style="border-radius: 20px">上传图标</button>
            </div>
          </div>
        </up-load-image>
        <div style="width: 800px;height: 464px;background-color: #FFF;"
             class="m-auto  border"
             v-if="imgs.length>0"
        >

          <div class="flex a-center p-l-20 p-r-20" style="background-color: #F6F8FC;height: 64px">
            <img src="../../../assets/common/ic_upload_icons@2x.png"
                 style="width: 24px;height: 24px">
            <up-load-image @uploadSuccess="uploadImageSuccess"
                           accept="image/*"
                           multiple
                           candrag
                           class="m-auto flex-column"
                           style="width: 800px;height: 64px"
                           picurl="company/about/"
            >
              <div slot="tip"
              >
                <div class="flex a-center j-center">将图标svg文件拖拽至此区域上传图标</div>
              </div>
            </up-load-image>
            <div class="flex-1 flex j-end">
              <up-load-image @uploadSuccess="uploadImageSuccess"
                             accept="image/*"
                             multiple
                             class="flex a-center j-center"
                             picurl="company/about/"
                             style="width: 98px;height: 120px;">
                <div slot="tip"
                >
                  <Button type="primary" style="border-radius: 20px">上传图标</button>
                </div>
              </up-load-image>

            </div>
          </div>
          <div class=" flex">
            <div style="width: 400px;height:400px;flex-wrap: wrap;align-content: start"
                 class="p-10 flex scrollbar o-y-auto">
              <div
                :key="index"
                class="m-l-10  m-t-10 item"
                style="height: 64px;width: 64px"
                @click="selectImg(item,index)"
                :class="{'item-selected':(index===selectedIndex),'item-normal':(index!==selectedIndex)}"
                v-for="(item,index) in imgs">
                <div style="position: relative;width: 64px;height: 64px">
                  <img :src="item.url" style=" width: 60px;height: 60px;"/>
                  <div class="flex a-end j-center  w-full h-full item-editable"
                       style="position: absolute;bottom: 0;left: 0;right: 0;height: 20px;background-color: #0000004d">
                    <div class="w-14 h-14 b-round flex a-center j-center m-b-5"
                         style="cursor: pointer;"
                         @click.stop="itemDelete(item,index)">
                      <img src="../../../assets/common/ic-delete@2x.png" class="w-14 h-14"/>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div style="width: 400px;height: 400px; padding: 10px">
              <div class="flex a-center m-t-20">
                <div class="f-s-0" style="min-width: 70px;text-align: right">名称：</div>
                <Input v-model="selectedImg.name" placeholder="名称" class="m-l-5 m-r-20"/>
              </div>
              <div class="flex a-center m-t-20">
                <div style="min-width:70px;text-align: right">标签：</div>
                <Input v-model="selectedImg.label" placeholder="标签" class="m-l-5 m-r-20"/>
              </div>
              <div class="flex a-center m-t-20">
                <div style="min-width: 70px;text-align: right">上传至：</div>
                <span class="m-l-5 m-r-20">{{ selectedImg.upload2Name }}</span>
              </div>
            </div>

          </div>
        </div>

        <div class="flex j-center m-t-20">
          <Button>取消</Button>
          <Button type="primary" class="m-l-50">确认</Button>
        </div>
      </div>


    </base-page-component>
  </div>
</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import draggable from 'vuedraggable'
import UpLoadVideo from '@/components/common/UpLoadVideo'
import VideoEditTest from '@/components/common/VideoEditTest'
// import ImgUpload from '@/components/common/ImgUpload'


export default {
  name: 'UploadIcon',
  components: {
    VideoEditTest,
    BasePageComponent,
    draggable,
    UpLoadVideo,
    UpLoadImage
  },
  props: {
    videoInfix: {
      type: String,
      default: ''
    },
    vidupload: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      imgs: [],
      selectedImg: {},
      selectedIndex: -1,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    uploadImageSuccess (data) {
      data.map(item => {
        this.imgs.push({
          'url': item.url,
          'name': '',
          'label': '',
          'upload2Name': '自定义图标库',
        })
      })
    },

    itemDelete (item, index) {
      this.imgs.splice(index, 1)
      this.selectedImg = {}
      this.selectedIndex = -1
    },
    selectImg (item, index) {
      this.selectedIndex = index
      this.selectedImg = item
    }

  },
  computed: {},
}
</script>

<style lang="scss" scoped>

.item {
}

.item-editable {
  display: none;
}

.item:hover .item-editable {
  display: flex;
}

.item-selected {
  border: 2px solid #0EA4FB;
}

.item-normal {
  border: 2px solid white;
}

</style>